<template>
  <a-time-range-picker class="my-time-range" :value="value" :format="props.format" :valueFormat="props.valueFormat"
    @change="change" />
</template>
<script setup>
import { ref, defineProps, defineEmits, watch } from 'vue';
import dayjs from 'dayjs';
const props = defineProps({
  modelValue: {},
  begin: {
    type: [String],
    default: ''
  },
  end: {
    type: [String],
    default: ''
  },
  valueFormat: {
    type: [String],
    default: 'HH:mm'
  },
  format: {
    type: [String],
    default: 'HH:mm'
  },
});

const emits = defineEmits(['update:modelValue', 'update:begin', 'update:end', 'change']);

const value = ref([]);
watch(() => props.modelValue, v => {
  if (v && v.length == 2) {
    value.value = [v[0], v[1]];
  }
}, { immediate: true });

const setFun = (v, name, i) => {
  if (v === '' || v === null) {
    value.value[i] = undefined;
  }
  if (v && v.length != props.valueFormat.length) {
    emits(`update:${name}`, v);
  }
  if (v) {
    value.value[i] = props[name];
  }
}

watch(() => props.begin, v => { setFun(v, 'begin', 0); }, { immediate: true });
watch(() => props.end, v => { setFun(v, 'end', 1); }, { immediate: true });

const change = (value, dateStr) => {
  let newDateStr = [];
  if (!dateStr[0] && !dateStr[1]) {
    newDateStr = [];
  } else {
    newDateStr = [dateStr[0], dateStr[1]];
  }
  emits('change', value, newDateStr);
  emits('update:modelValue', newDateStr);
  emits('update:begin', newDateStr[0]);
  emits('update:end', newDateStr[1]);
}

</script>
<style scoped>
.my-time-range {
  width: 100%;
}
</style>
